import type {
  AutomationEntityType,
  AutomationTriggerEvent,
} from '@/gql/graphql';
import {
  type AnyAutomationAction,
  type AnyAutomationCondition,
  getActionDescription,
  getConditionDescription,
  getTriggerDescriptionForAutomation,
} from '@/helpers/automationDescriptions';
import { useTranslation } from '@/i18n';

/**
 * Hook that provides functions to generate human-readable descriptions
 * for automation conditions, actions, and titles.
 */
export const useAutomationDescriptions = () => {
  const t = useTranslation();

  return {
    getTriggerDescriptionForAutomation: (
      entityType: AutomationEntityType,
      triggerEvent: AutomationTriggerEvent
    ) => getTriggerDescriptionForAutomation(t, entityType, triggerEvent),
    getConditionDescription: (condition: AnyAutomationCondition) =>
      getConditionDescription(t, condition),
    getActionDescription: (action: AnyAutomationAction) =>
      getActionDescription(t, action),
  };
};
